import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useRecoilQuery } from '../../../../../../../hooks/useRecoilQuery';
import {
  incomeTaxBaseYearReportsQuery,
  incomeTaxTypeReportsQuery,
} from '../../../../../../../store/customerDetail/reports/selectors';

import { HeaderDesktop } from './desktop';
import { HeaderMobile } from './mobile';

export type QueryPropsType = {
  loading: boolean;
  error: Error | undefined;
  refresher: () => void;
  data: {
    label: string;
    value: string;
  }[];
};
export interface HeaderResponsiveProps {
  incomeTaxTypeReports: QueryPropsType;
  incomeTaxBaseYearReports: QueryPropsType;
}

export const Header: React.FC = () => {
  const incomeTaxBaseYearReports = useRecoilQuery(incomeTaxBaseYearReportsQuery);
  const incomeTaxTypeReports = useRecoilQuery(incomeTaxTypeReportsQuery);

  const params = {
    incomeTaxTypeReports,
    incomeTaxBaseYearReports,
  };

  const responsiveHeader = useBreakpointValue({
    base: <HeaderMobile {...params} />,
    md: <HeaderDesktop {...params} />,
  });

  return responsiveHeader;
};
